const OPTION_SEPARATOR = "::";
const PROPERTY_SEPARATOR = "||";

export class CompatibleQuantitiesCache {
  private compatibilities: { [serializedKey: string]: number[] };
  private static instance: CompatibleQuantitiesCache;

  constructor() {
    this.compatibilities = {};
  }

  static getInstance(): CompatibleQuantitiesCache {
    if (!CompatibleQuantitiesCache.instance) {
      CompatibleQuantitiesCache.instance = new CompatibleQuantitiesCache();
    }
    return CompatibleQuantitiesCache.instance;
  }

  serializeSelection(selections: { [key: string]: string }): string {
    const orderedSelections: { [key: string]: string } = {};
    Object.keys(selections)
      .sort()
      .map(key => {
        orderedSelections[key] = selections[key];
      });

    return Object.keys(orderedSelections)
      .reduce((result: string[], key: string): string[] => {
        result.push(`${key}${OPTION_SEPARATOR}${orderedSelections[key]}`);
        return result;
      }, [])
      .join(PROPERTY_SEPARATOR);
  }

  public getCompatibleQuantities(selections: { [key: string]: string }): number[] | undefined {
    const key = this.serializeSelection(selections);
    return this.compatibilities[key] || undefined;
  }

  public setCompatibleQuantities(
    selections: { [key: string]: string },
    compatibleQuantities: number[]
  ) {
    this.compatibilities[this.serializeSelection(selections)] = compatibleQuantities;
  }
}
